import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delete-event-confirmation-dialog',
  templateUrl: './delete-event-confirmation-dialog.component.html',
  styleUrls: ['./delete-event-confirmation-dialog.component.scss']
})
export class DeleteEventConfirmationDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
